import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { CollectionPaths } from '@models/collections';
import { MatterMortgage } from '@models/mortgage';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Repo } from '@repos/repo.service';
import { UserProfileState } from '@state/user-profile';

export interface MatterMortgagePathParams {
	matterId: string;
}

@Injectable({
	providedIn: 'root',
})
export class MatterMortgagesRepoService extends Repo<
	MatterMortgage,
	MatterMortgagePathParams
> {
	@SelectSnapshot(UserProfileState.getCurrentBusinessId) businessId;

	constructor(private firestore: AngularFirestore) {
		super(firestore);
	}

	GetCollectionPath(pathParams: MatterMortgagePathParams): string {
		return CollectionPaths.business_matter_mortgages(
			this.businessId,
			pathParams.matterId,
		);
	}
}
